import { Injectable } from '@angular/core';

import { BetslipUnknownPick } from '../../../core/picks/betslip-unknown-pick';
import { pickIdFactory } from '../../../core/picks/pick-id';
import { IBetslipPickSavedState, IBetslipPickState, defaultPickState } from '../state';
import { BetslipPickStorageLoader } from './betslip-pick-storage-loader';

@Injectable()
export default class BetslipPicksStateStorageService {
    constructor(private pickLoader: BetslipPickStorageLoader) {}

    toSavedState(state: IBetslipPickState): IBetslipPickSavedState {
        return {
            pickList: state.pickList.filter((p) => !BetslipUnknownPick.isPick(p)).map((p) => p.toJSON()),
            ui: state.ui,
            lastPickError: state.lastPickError
                ? { ...state.lastPickError, pickId: state.lastPickError.pickId ? state.lastPickError.pickId.toString() : undefined }
                : state.lastPickError,
        };
    }

    fromSavedState(state: IBetslipPickSavedState | undefined): IBetslipPickState {
        if (!state) {
            return defaultPickState;
        }

        return {
            pickList: state.pickList.map((pl) => this.pickLoader.loadPick(pl)),
            ui: state.ui,
            lastPickError: state.lastPickError
                ? { ...state.lastPickError, pickId: state.lastPickError.pickId ? pickIdFactory(state.lastPickError.pickId?.toString()) : undefined }
                : state.lastPickError,
        };
    }
}
